import { DatePipe, formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'date_date_time' })
export class DateDateTimePipe {
    constructor() {}
    transform(value: string): string | null {
        return new DatePipe('en-CA').transform(value, 'YYYY-MM-dd hh:mm a');
    }
}
